import { router } from '@inertiajs/react';

import { getDocument } from '@/lib/utils';

export interface IdentifyEvent {
  event: 'll_identify';
  email: string;
}

export interface TrialStartedEvent {
  event: 'trial_started';
  plan: string;
  value?: number;
}

export type GoogleTagManagerEvent = IdentifyEvent | TrialStartedEvent;

type WindowWithDataLayer = Window & {
  dataLayer?: unknown[];
};

export function pushToDataLayer(trackingData: GoogleTagManagerEvent[] | null | undefined): void {
  if (!trackingData?.length) return;

  const browserWindow = getDocument()?.defaultView as WindowWithDataLayer | null | undefined;
  if (!browserWindow) return;

  browserWindow.dataLayer ||= [];
  browserWindow.dataLayer.push(...trackingData);
}

const trackingDataOf = (pageProps: Record<string, unknown>) =>
  pageProps.trackingData as GoogleTagManagerEvent[] | undefined;

// Controllers share trackingData on the pages GTM should hear about. The first page is pushed
// here; later pages arrive through 'success', which fires for every Inertia response, including
// visits that replace history, but not when back/forward restores a page from history.
export function listenForTrackingData(initialPageProps: Record<string, unknown>): VoidFunction {
  pushToDataLayer(trackingDataOf(initialPageProps));

  return router.on('success', (event) => {
    pushToDataLayer(trackingDataOf(event.detail.page.props));
  });
}
